import React, { useState } from 'react';
import { Box } from '@mui/material';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { PropertiesPanel } from '@paragon/layout-models';
import { DistanceField } from '@paragon/material';
import { calculateMemberPolygon } from '@paragon/three-shared';

import { finishInsertingChordStack } from '../../../../store/actions/insertActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import InsertionPanelContainer from './InsertionPanelContainer';

export function ChordStackInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const component = useAppSelector((state) => {
    const activeComponent = getActiveComponentDesign(state)?.component;
    if (!activeComponent) throw new Error('Expected an active component');
    return activeComponent;
  });
  const member = useAppSelector((state) => {
    const { insertingObjectInfo } = state.application;
    if (insertingObjectInfo?.type !== 'memberStack') throw new Error('Expected to be inserting a member stack');
    const component = getActiveComponentDesign(state)?.component;
    if (!component) throw new Error('Expected an active component');
    const member = component.members.find((member) => member.guid === insertingObjectInfo.memberGuid);
    if (!member) throw new Error('Expected member to exist');
    return member;
  });

  const [startLocation, setStartLocation] = useState(() =>
    Math.min(...calculateMemberPolygon(member, component)!.vertices.map((vertex) => vertex.x)),
  );
  const [endLocation, setEndLocation] = useState(() =>
    Math.max(...calculateMemberPolygon(member, component)!.vertices.map((vertex) => vertex.x)),
  );

  return (
    <InsertionPanelContainer onInsert={() => dispatch(finishInsertingChordStack(startLocation, endLocation))}>
      <PropertiesPanel title="Member Stack Insertion">
        <Box sx={{ p: 2, mb: 9, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ flexGrow: 1 }}>
            <MaterialPropertyValuePair property="Member" value={member.name} />
            <Box sx={{ p: 1 }}>
              <DistanceField
                label="Start Location"
                value={startLocation}
                onSubmit={(value) => setStartLocation(value)}
                sx={{ mx: 2, width: 200 }}
              />
            </Box>
            <Box sx={{ p: 1 }}>
              <DistanceField
                label="End Location"
                value={endLocation}
                onSubmit={(value) => setEndLocation(value)}
                sx={{ mx: 2, width: 200 }}
              />
            </Box>
          </Box>
        </Box>
      </PropertiesPanel>
    </InsertionPanelContainer>
  );
}
